import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  effect,
  EffectRef,
  inject,
  input,
  signal,
} from '@angular/core';
import { IconComponent, IconType } from '@webapp/ui';

const TAG_TO_ICON: Record<string, IconType> = {
  classic_car: 'classic_car_risk',
  motor_bike: 'motor_bike_risk',
  quad: 'quad_risk',
  personal_accidents: 'personal_accidents_risk',
  transportation_goods: 'transportation_goods_risk',
  car: 'car_risk',
  boat: 'boat_risk',
  house: 'house_risk',
  bicycle: 'bycicle_risk',
  travel: 'travel_risk',
  civil_events: 'civil_events_risk',
};

const TAG_TO_LABEL: Record<string, string> = {
  classic_car: 'Auto clásico',
  motor_bike: 'Moto',
  quad: 'Cuatriciclo',
  personal_accidents: 'Accidentes personales',
  transportation_goods: 'Transporte de mercadería',
  car: 'Auto',
  boat: 'Embarcación',
  house: 'Hogar',
  bicycle: 'Bicicleta',
  travel: 'Asistencia al viajero',
  civil_events: 'Eventos',
};

const ICON_KEYS = Object.keys(TAG_TO_ICON);

@Component({
  selector: 'app-risk-loader',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './risk-loader.component.html',
  styleUrl: './risk-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskLoaderComponent {
  subtitle = input<string>();
  riskTag = input<string>();

  currentIndex = signal(0);

  currentRiskKey = computed(() => ICON_KEYS[this.currentIndex() % ICON_KEYS.length]);

  icon = computed<IconType>(() => TAG_TO_ICON[this.currentRiskKey()]);

  label = computed<string>(() => TAG_TO_LABEL[this.currentRiskKey()] ?? '');

  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    const effectRef: EffectRef = effect(() => {
      const tag = this.riskTag();
      const foundIndex = ICON_KEYS.indexOf(tag ?? '');
      const startIndex = foundIndex === -1 ? 0 : foundIndex;
      this.currentIndex.set(startIndex);

      const id = setInterval(
        () => this.currentIndex.update(i => (i + 1) % ICON_KEYS.length),
        1200,
      );
      this.destroyRef.onDestroy(() => clearInterval(id));

      effectRef.destroy();
    });
  }
}
